<div
  [class.open]="isVisible$ | async"
  class="oph-drawer-backdrop"
  [ngClass]="{'oph-drawer-backdrop__hide': hideBackdrop}"
  (click)="closeDrawer()"
></div>
<div [class.open]="isVisible$ | async" class="oph-drawer">
  <div class="oph-drawer__container" [ngClass]="{'oph-drawer__container__hide-scrollbar': hideScrollbar}">
    @if (!hideCloseButton) {
      <button mat-icon-button aria-label="Close drawer button" type="button" (click)="closeDrawer()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <ng-content></ng-content>
    <ng-container #drawerContent></ng-container>
  </div>
</div>
